// extracted by mini-css-extract-plugin
module.exports = {"infoModalContent":"Header_infoModalContent__2Khei"};